var _style, _g, _rect, _rect2, _rect3, _polygon, _rect4, _polygon2, _polygon3, _polygon4, _polygon5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXitasoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 419.11 105.21",
    style: {
      enableBackground: "new 0 0 419.11 105.21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.36,59.31L11.84,76.78H0l17.8-25.45L1.83,28.29h12.04l10.4,14.92l9.81-14.92h11.84L29.77,51.13L47.7,76.78 H35.53L23.36,59.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.68,28.29h10.67v48.48H57.68V28.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.63,37.98H77.81v-9.68h44.36v9.68h-16.75v38.8h-10.8V37.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.1,71.15l5.36-7.72c5.17,3.47,11.19,5.17,17.4,5.17c9.49,0,11.26-1.83,11.26-5.89 c0-3.99-4.06-4.78-11.52-5.82c-12.96-1.83-19.7-4.19-19.7-14.72c0-10.8,6.54-14.65,20.22-14.65c9.88,0,15.9,2.29,19.63,4.78 l-5.76,8.31c-3.07-2.03-8.77-3.73-14-3.73c-7.59,0-9.42,1.5-9.42,5.03c0,3.93,3.99,4.65,11.71,5.76 c11.65,1.7,19.43,3.6,19.43,14.52c0,9.81-5.37,15.31-21.53,15.31C190.58,77.5,182.6,75.21,177.1,71.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.16,52.5c0-18.19,10.21-24.99,25.65-24.99c15.44,0,25.71,6.8,25.71,24.99c0,18.25-10.27,25.06-25.71,25.06 C240.38,77.56,230.16,70.76,230.16,52.5z M270.67,52.7c0-9.49-3.73-15.38-14.85-15.38c-11.12,0-14.85,5.89-14.85,15.38 c0,9.49,3.73,15.44,14.85,15.44C266.94,68.14,270.67,62.18,270.67,52.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "151.84,27.97 140.97,27.97 121.54,76.78 132.01,76.78 146.14,40.66 153.73,59.96 144.83,59.96  141.37,68.79 157.13,68.79 160.28,76.78 171.4,76.78  "
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 391.96,
    y: 52.81,
    transform: "matrix(0.7068 -0.7074 0.7074 0.7068 64.2232 300.6395)",
    className: "st0",
    width: 5.72,
    height: 40.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 383.87,
    y: 60.91,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 56.0126 297.1185)",
    className: "st0",
    width: 5.72,
    height: 40.04
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 366.71,
    y: 21.42,
    transform: "matrix(0.7071 -0.7072 0.7072 0.7071 96.1183 280.5878)",
    className: "st0",
    width: 40.04,
    height: 5.73
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "390.76,0 366.5,24.27 342.23,0 338.18,4.05 366.5,32.36 394.81,4.05 "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 374.81,
    y: 29.51,
    transform: "matrix(0.7074 -0.7068 0.7068 0.7074 92.6378 288.5374)",
    className: "st0",
    width: 40.04,
    height: 5.72
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "394.84,52.61 419.11,28.34 415.06,24.29 386.74,52.61 415.06,80.92 419.11,76.87 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "317.94,24.29 313.89,28.34 338.16,52.61 313.89,76.87 317.94,80.92 346.25,52.61 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "330.09,12.15 326.04,16.19 362.45,52.61 326.04,89.02 330.09,93.07 370.55,52.61 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "394.81,101.17 366.5,72.85 338.18,101.17 342.23,105.21 366.5,80.95 390.76,105.21 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXitasoLogo);
export default __webpack_public_path__ + "static/media/XitasoLogo.c479c9de39c31b5d19af4fe088a183e7.svg";
export { ForwardRef as ReactComponent };